import * as React from 'react'
import { IRiderLocationObject } from '../../../../types'

interface ILocationItemState {
  hover: boolean
}

export interface ILocationListItemProps {
  location: IRiderLocationObject
}

class LocationListItem extends React.Component<ILocationListItemProps, ILocationItemState> {
  constructor(props: ILocationListItemProps) {
    super(props)
    this.state = {
      hover: false
    }
  }

  public render() {
    const { location } = this.props
    if (!location) {
      return null
    }

    const addressParts = location.fullAddress.split(',')
    const shortAddress = addressParts[0] + ', ' + addressParts[1]

    return (
      <div
        className={`flex ${this.state.hover && 'bg-light-grey2'} px1`}
        onMouseEnter={() => this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}
      >
        <div className='col-3'>
          <span className='h5'>{location.placeName}</span>
        </div>
        <div className='col-2'>
          <span className='h5'>{location.phoneNumber}</span>
        </div>
        <div className='col-4'>
          {/* TODO: Add map widget & icon */}
          <span className='h5'>{shortAddress}</span>
        </div>
        <div className='col-3'>
          <span className='h5'>{location.note}</span>
        </div>
      </div>
    )
  }
}

export default LocationListItem



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/location/LocationtListItem.tsx